import { gql } from '@apollo/client';

export * from './assetRemove.mutation.generated';

export const ASSET_REMOVE = gql`
  mutation assetRemove($assetId: ID!) {
    assetRemove(input: { assetId: $assetId }) {
      success
      errors
      softwareEscrow {
        id
        depositStatus
        policy {
          activate
          deferActivation
          createDepositSuggestedChange
        }
      }
    }
  }
`;
